import { apiFetch, jsonOpts, parseJson } from "./client";
import type {
  EquipmentModel,
  JohnDeereAccountStatus,
  JohnDeereConnection,
  LiveMachines,
} from "./types";

export async function getUnassignedConnections(): Promise<
  JohnDeereConnection[]
> {
  return parseJson<JohnDeereConnection[]>(
    await apiFetch("/api/jd/connections/unassigned")
  );
}

export async function getAllConnections(): Promise<JohnDeereConnection[]> {
  return parseJson<JohnDeereConnection[]>(
    await apiFetch("/api/jd/connections")
  );
}

export async function getAccountStatus(
  accountId: string
): Promise<JohnDeereAccountStatus> {
  return parseJson<JohnDeereAccountStatus>(
    await apiFetch(`/api/jd/connections/for-account/${accountId}`)
  );
}

export async function getLiveMachines(
  accountId: string
): Promise<LiveMachines> {
  return parseJson(
    await apiFetch(`/api/jd/connections/for-account/${accountId}/live-machines`)
  );
}

export async function searchEquipmentModels(
  q: string
): Promise<EquipmentModel[]> {
  return parseJson<EquipmentModel[]>(
    await apiFetch(
      `/api/jd/equipment-models?${new URLSearchParams({ q }).toString()}`
    )
  );
}

export async function revokeConnection(connectionId: string): Promise<void> {
  await apiFetch(`/api/jd/connections/${connectionId}/revoke`, {
    method: "POST",
  });
}

export async function syncAccount(accountId: string): Promise<{
  machines_created: number;
  machines_updated: number;
  fields_created: number;
  fields_updated: number;
  last_synced_at: string;
}> {
  return parseJson(
    await apiFetch(`/api/jd/connections/for-account/${accountId}/sync`, {
      method: "POST",
    })
  );
}

export async function assignConnection(
  connectionId: string,
  customerAccountId: string
): Promise<JohnDeereConnection> {
  return parseJson<JohnDeereConnection>(
    await apiFetch(`/api/jd/connections/${connectionId}/assign`, {
      ...jsonOpts,
      method: "POST",
      body: JSON.stringify({ customer_account_id: customerAccountId }),
    })
  );
}
